var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "bnr",
    attrs: {
      "href": "https://www.toriyasaimiso.jp/shop/",
      "target": "_blank"
    }
  }, [_c('picture', [_c('source', {
    attrs: {
      "media": "(min-width: 768px)",
      "srcset": "static/assets/images/bnr_ec.png 1x, static/assets/images/bnr_ec@2x.png 2x"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "media": "(min-width: 320px)",
      "srcset": "static/assets/images/bnr_ec@sp.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "static/assets/images/bnr_ec.png",
      "alt": "東村アキコの味噌鍋革命セレクトセット"
    }
  })])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22eed36e","hasScoped":true,"transformToRequire":{"video":"src","source":"srcset","img":["src","srcset"],"image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Banner.vue
// module id = 63
// module chunks = 0